import { faDownLeftAndUpRightToCenter, faUpRightAndDownLeftFromCenter } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import If from "components/common/If";
import Translate from "components/common/Translate";
import { useState } from "react";

export type AccordionPropsType = {
    name: string,
    title: string | React.ReactNode,
    open?: boolean,
    removeOnCollapse?: boolean
    children: any,
    hidden?: boolean | (() => boolean)
}

const Accordion = (props: AccordionPropsType) => {
    const [open, setOpen] = useState<boolean>(props.open ? true : false);

    if(props.hidden === true || (typeof props.hidden === 'function' && props.hidden() === true)) {
        return <></>;
    }

    return (
        <div className="w-full">
            <header onClick={() => setOpen(!open)} className="py-4 border-b theme-border  w-full cursor-pointer inline-flex">
                <div className="w-full">
                    <span className="my-auto text-xl">
                        {typeof props.title == 'string' ? <Translate i18nKey={props.title} /> : props.title}
                    </span>
                </div>
                <div className="my-auto">
                    <If condition={open}>
                        <FontAwesomeIcon icon={faDownLeftAndUpRightToCenter} />
                    </If>
                    <If condition={!open}>
                        <FontAwesomeIcon icon={faUpRightAndDownLeftFromCenter} />
                    </If>
                </div>
            </header>
            <If condition={!props.removeOnCollapse || open}>
                <section className={`py-2 px-2 md:px-4 ${!open ? 'hidden' : ''} bg-neutral-50 dark:bg-neutral-900`}>
                        {props.children}
                </section>
            </If>
        </div>
    );
};

export default Accordion;
